import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { MerchantService } from '../_services/merchant.service';

@Injectable({
  providedIn: 'root'
})
export class AuthPublicGuard  {
  private readonly router: Router = inject(Router);
  private readonly merchantService: MerchantService = inject(MerchantService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.merchantService.checkSession();
    return true;
  }
}